import { ConfigProvider, Modal } from "antd";
import { Dispatch, ReactNode, SetStateAction, useEffect } from "react";
import React from "react";
import { MODAL_THEME } from "@/core/themes/modal.theme";
import { AuditLogModel } from "@/core/models/audit-log.model";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { AUDIT_LOG_DETAIL_MAP } from "@/core/consts/audit-log.maps";

interface CreateModalProps {
    isModalOpen: boolean,
    setIsModalOpen: Dispatch<SetStateAction<boolean>>,
    data?: AuditLogModel,
}


export const DetailModal: React.FC<CreateModalProps> = ({isModalOpen, setIsModalOpen, data}) => {

    const init = async () => {}
    //componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {init()}, []);
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const generateRow = () => {
        if (!data) return null;
        const map = AUDIT_LOG_DETAIL_MAP[data.title];
        if (!map) return null;
        const rows: ReactNode[] = [];
        data.auditLogDetails.forEach(detail => {
            const fieldName = map[detail.fieldName];
            rows.push(<tr 
                style={{background: detail.oldValue!=detail.newValue?"var(--table-changed)":undefined}}>
                <td>{fieldName??detail.fieldName}</td>
                <td>{detail.oldValue}</td>
                <td>{detail.newValue}</td>
            </tr>)
        })
        return rows;
    }

    return (
        <ConfigProvider theme={MODAL_THEME}>
            <Modal open={isModalOpen} onCancel={handleCancel} width={1200} style={{ top: 20 }}
                styles={{
                    mask: {
                        backdropFilter: 'blur(2px)',
                        backgroundColor: 'var(--primary-mask)'
                    }
                }}
                footer={[]}
            >
                <div className="flex flex-row w-full items-start justify-start select-none">
                    <p className="ml-2 text-2xl font-bold text-primary">THÔNG TIN NHẬT KÝ</p>
                </div>
                <div className="px-2 py-4">
                    <div className="text-lg pb-2">
                        <p><b>Loại đối tượng tác động: <span  style={{color: "var(--primary-color)"}}>{data?.tableName.toUpperCase()}</span></b></p>
                        <p><b>Người tác động: </b>{data?.username}</p>
                        <p><b>Thời gian tác động: </b>{data&&formatDateTimePipe(data?.timestamp)}</p>
                    </div>
                    <div className="mb-5 border-t border-dashed border-gray-300"></div>
                    <p className="font-bold text-xl text-primary mb-2">CHI TIẾT THAY ĐỔI</p>
                    <table className="invoice-table-bordered primary-table w-full">
                            <tr>
                                <th>Tên trường</th>
                                <th>Giá trị cũ</th>
                                <th>Giá trị mới</th>
                            </tr>
                        <tbody>
                            {generateRow()}
                        </tbody>
                    </table>
                </div>
            </Modal>
        </ConfigProvider>
    )
}
